import { TIFrameFields, TIFrameProps } from '../types/IFrame.types';

export class IFrameModel {
  public readonly fields: null | TIFrameFields;

  constructor(props: TIFrameProps) {
    this.fields = props.fields || null;
  }

  get url(): string {
    return this.fields?.Link?.value?.url as string;
  }

  get height(): number {
    const _height = Number.parseInt(this.fields?.Height?.value ?? '0');
    
    return Number.isNaN(_height) ? 1000  : _height;
  }
}
